import Button from "../../../components/button/Button";
import ArrowSmall from "../../../components/svg/ArrowSmall";
import { useSelector } from "react-redux";
import { selectReservation } from "../../../features/reservation/reservationSlice";
import { resetReservations } from "../../../helpers/reservation";

export default function ConfirmationCheckOut() {
	const reservation = useSelector(selectReservation);

	return (
		<div className="flex justify-center items-center flex-col h-screen w-full">
			<div className="flex justify-center items-center flex-col w-full">
				<div className="text-h1 text-center">
					{reservation.FirstNames}!<br />You're checked out now.
				</div>

				<div className="mt-12 text-center">
					<div className="text-h2">
						<div>
							Thanks for staying over! <br />
							Hope to see you next time ❤️
						</div>
					</div>
				</div>
			</div>
			<div className="mt-12 w-full">
				<Button
					type="button"
					onClick={() => resetReservations()}
					text="Close"
					suffix={<ArrowSmall />}
				/>
			</div>
		</div>
	);
}
